import { NgModule, ModuleWithProviders, Optional, SkipSelf } from '@angular/core';
import { INavigationService } from '@pershing/pershing-core';
import { PortalNavigationService } from './services/portal.navigation.service';
import { AWRContextService } from './services/AWRContextService';
export const NXI_CORE_PROVIDERS: any[] = [
          { provide: INavigationService, useClass: PortalNavigationService },
          AWRContextService
];

@NgModule({
})
export class NxiPortalCoreModule {
  static forRoot(): ModuleWithProviders<NxiPortalCoreModule> {
    return {
        ngModule: NxiPortalCoreModule,
        providers: [
            ...NXI_CORE_PROVIDERS
        ]
    };
}
constructor(@Optional() @SkipSelf() parentModule: NxiPortalCoreModule) {
    if (parentModule) {
        throw new Error(
            'NxiPortalCoreModule is already loaded. Import it in the AppModule only');
    }
}
 }
